export function isScrollNearTop(event: UIEvent, threshold = 0.1) {
  const node = event.target;

  return node instanceof HTMLElement && node.scrollTop < node.clientHeight * threshold;
}
